import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import EmailAccountFactory from "../../Entity/Factories/EmailAccountFactory";
import SubscriptionFactory from "../../Entity/Factories/SubscriptionFactory";
import { SubscriptionInterface } from "../../Entity/Entities/Subscription/SubscriptionInterface";
import { ActionInterface } from "../../Interface/ActionInterface";
import { EmailAccountInterface } from "../../Entity/Entities/EmailAccount/EmailAccountInterface";
import Translator from "../../Translation/Translator";

export default function* emailAccountCreate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_CLEAR
    });

    yield put({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_REQUEST
    });

    const res = yield call(Http.post, `email-account`, action.payload?.imapCredentials);
    const emailAccount: EmailAccountInterface = EmailAccountFactory.create(res.data.emailAccount);
    const subscription: SubscriptionInterface = SubscriptionFactory.create(res.data.subscription);

    yield put({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_SUCCESS,
      payload: {
        emailAccount: emailAccount
      }
    });

    yield put({
      type: Constants.GLOBAL_SUBSCRIPTION_CREATE_SUCCESS,
      payload: {
        subscription: subscription
      }
    });

    yield put({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_TOGGLE_DIALOG,
      payload: {
        isDialogOpen: false,
        isUpdating: false
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-action-successful"),
        type: "success"
      }
    });

  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_FAILURE,
      payload: {
        err: err
      }
    });

    yield put({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_TOGGLE_DIALOG,
      payload: {
        isDialogOpen: true
      }
    });
  }
}

export function* watchEmailAccountCreate() {
  yield takeEvery(Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_START, emailAccountCreate);
}
